import { useState, Fragment } from 'react'
import LOGO from '../../IMG/logo192.jpg'
import {
    Dialog,
    DialogPanel,
    Popover,
    PopoverGroup,
    Transition,
} from '@headlessui/react'
import {
    Bars3Icon,
    XMarkIcon,
    BuildingOffice2Icon,
    NewspaperIcon,
    InformationCircleIcon,
    BriefcaseIcon,
} from '@heroicons/react/24/outline'
import LoadDataHospital from '../../Func/LoadDataHospital'
import { Link } from 'react-router-dom'
import LoadDataNewsActivity from '../../Func/LoadDataNewsActivity'
import NewsActivity from '../Drawers/NewsActivity'

const Navbar = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const dataClinic = LoadDataHospital()
    const dataNewsActivity = LoadDataNewsActivity()
    const [openModalNews, setOpenModalNews] = useState(false)

    return (
        <header className="bg-white/98 backdrop-blur-xl sticky top-0 z-50 border-b border-slate-200/80 shadow-lg shadow-blue-900/5">
            <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 lg:px-8 lg:py-4">
                {/* Logo Section - Enhanced with modern styling */}
                <div className="flex lg:flex-1">
                    <Link to="/" className="-m-1.5 p-1.5 flex items-center gap-3 group transition-all duration-300">
                        <div className="relative">
                            <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-orange-500 rounded-2xl blur-md opacity-0 group-hover:opacity-40 transition-opacity duration-300"></div>
                            <img
                                alt="ราชพฤกษ์ไตเทียม - ศูนย์ฟอกเลือดมาตรฐาน"
                                src={LOGO}
                                className="relative h-12 w-auto rounded-2xl shadow-lg transition-all duration-300 group-hover:scale-105 group-hover:shadow-xl"
                            />
                            <div className="absolute -bottom-1 -right-1 h-4 w-4 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full border-2 border-white shadow-md animate-pulse"></div>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-xl font-black bg-gradient-to-r from-blue-900 via-blue-700 to-orange-600 bg-clip-text text-transparent tracking-tight leading-none">
                                ราชพฤกษ์ไตเทียม
                            </span>
                            <span className="text-[9px] font-bold text-slate-500 tracking-[0.15em] uppercase mt-0.5">Hemodialysis Center</span>
                        </div>
                    </Link>
                </div>

                {/* Mobile Hamburger - Enhanced */}
                <div className="flex lg:hidden">
                    <button
                        type="button"
                        onClick={() => setMobileMenuOpen(true)}
                        className="-m-2.5 inline-flex items-center justify-center rounded-2xl p-2.5 text-blue-900 hover:bg-gradient-to-br hover:from-orange-50 hover:to-blue-50 hover:text-orange-600 transition-all duration-300 outline-none shadow-sm hover:shadow-md"
                        aria-label="เปิดเมนู"
                    >
                        <Bars3Icon aria-hidden="true" className="h-7 w-7" />
                    </button>
                </div>

                {/* Desktop Navigation - Modern & Clean */}
                <PopoverGroup className="hidden lg:flex lg:gap-x-2">
                    <Link
                        to="/registration"
                        className="group flex items-center gap-2 px-5 py-2.5 text-sm font-bold leading-6 text-slate-700 hover:text-blue-900 hover:bg-gradient-to-br hover:from-blue-50 hover:to-slate-50 rounded-2xl transition-all duration-300"
                    >
                        <BriefcaseIcon className="w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                        สนใจสมัครงานกับเรา
                    </Link>

                    <Link
                        to="/hemodialysisUnit"
                        className="group flex items-center gap-2 px-5 py-2.5 text-sm font-bold leading-6 text-slate-700 hover:text-blue-900 hover:bg-gradient-to-br hover:from-blue-50 hover:to-slate-50 rounded-2xl transition-all duration-300"
                    >
                        <BuildingOffice2Icon className="w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                        หน่วยไตเทียม
                    </Link>

                    <button
                        onClick={() => setOpenModalNews(true)}
                        className="group flex items-center gap-2 px-5 py-2.5 text-sm font-bold leading-6 text-slate-700 hover:text-blue-900 hover:bg-gradient-to-br hover:from-blue-50 hover:to-slate-50 rounded-2xl transition-all duration-300 outline-none"
                    >
                        <NewspaperIcon className="w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                        ข่าวสารและกิจกรรม
                    </button>

                    <Link
                        to="/about"
                        className="group flex items-center gap-2 px-5 py-2.5 text-sm font-bold leading-6 text-slate-700 hover:text-blue-900 hover:bg-gradient-to-br hover:from-blue-50 hover:to-slate-50 rounded-2xl transition-all duration-300"
                    >
                        <InformationCircleIcon className="w-5 h-5 text-slate-400 group-hover:text-blue-600 transition-colors" />
                        เกี่ยวกับเรา
                    </Link>
                </PopoverGroup>

                {/* Right CTA - Premium Design */}
                <div className="hidden lg:flex lg:flex-1 lg:justify-end">
                    <Link
                        to="/"
                        className="group relative flex items-center gap-3 rounded-2xl bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 px-7 py-3 text-sm font-bold text-white shadow-xl shadow-blue-900/30 hover:shadow-2xl hover:shadow-blue-900/40 transition-all duration-300 active:scale-95 overflow-hidden"
                    >
                        <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-orange-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        <span className="relative tracking-tight">Ratchaphruek Portal</span>
                        <div className="relative flex h-6 w-6 items-center justify-center rounded-full bg-white/20 group-hover:bg-white/30 transition-colors">
                            <div className="h-2 w-2 rounded-full bg-orange-400 group-hover:bg-white animate-pulse"></div>
                        </div>
                    </Link>
                </div>
            </nav>

            {/* Mobile Menu Panel - Enhanced Design */}
            <Transition show={mobileMenuOpen} as={Fragment}>
                <Dialog onClose={setMobileMenuOpen} className="lg:hidden">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 z-50 bg-gradient-to-br from-blue-900/50 via-slate-900/50 to-orange-900/50 backdrop-blur-md" />
                    </Transition.Child>

                    <Transition.Child
                        as={Fragment}
                        enter="transform transition ease-in-out duration-400"
                        enterFrom="translate-x-full"
                        enterTo="translate-x-0"
                        leave="transform transition ease-in-out duration-300"
                        leaveFrom="translate-x-0"
                        leaveTo="translate-x-full"
                    >
                        <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-gradient-to-br from-white via-slate-50 to-blue-50 px-6 py-6 sm:max-w-sm border-l border-slate-200 shadow-2xl">
                            <div className="flex items-center justify-between mb-8">
                                <Link to="/" onClick={() => setMobileMenuOpen(false)} className="-m-1.5 p-1.5 flex items-center gap-3 group">
                                    <img alt="ราชพฤกษ์ไตเทียม" src={LOGO} className="h-11 w-auto rounded-2xl shadow-md group-hover:shadow-lg transition-shadow" />
                                    <span className="font-black text-blue-900 text-lg tracking-tight">ราชพฤกษ์ไตเทียม</span>
                                </Link>
                                <button
                                    type="button"
                                    onClick={() => setMobileMenuOpen(false)}
                                    className="-m-2.5 rounded-2xl p-2.5 text-slate-500 hover:text-orange-600 hover:bg-orange-50 transition-all duration-300 outline-none"
                                    aria-label="ปิดเมนู"
                                >
                                    <XMarkIcon aria-hidden="true" className="h-7 w-7" />
                                </button>
                            </div>

                            <div className="flow-root">
                                <div className="space-y-3 py-6">
                                    <Link
                                        to="/registration"
                                        onClick={() => setMobileMenuOpen(false)}
                                        className="group flex items-center gap-4 rounded-2xl px-5 py-4 text-base font-black leading-7 text-blue-900 hover:bg-white hover:shadow-lg transition-all duration-300"
                                    >
                                        <div className="p-2 rounded-xl bg-green-100 text-green-600 group-hover:bg-green-600 group-hover:text-white transition-all">
                                            <BriefcaseIcon className="w-6 h-6" />
                                        </div>
                                        สนใจสมัครงานกับเรา
                                    </Link>

                                    <Link
                                        to="/hemodialysisUnit"
                                        onClick={() => setMobileMenuOpen(false)}
                                        className="group flex items-center gap-4 rounded-2xl px-5 py-4 text-base font-black leading-7 text-blue-900 hover:bg-white hover:shadow-lg transition-all duration-300"
                                    >
                                        <div className="p-2 rounded-xl bg-blue-100 text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-all">
                                            <BuildingOffice2Icon className="w-6 h-6" />
                                        </div>
                                        หน่วยไตเทียม
                                    </Link>

                                    <button
                                        onClick={() => { setOpenModalNews(true); setMobileMenuOpen(false); }}
                                        className="group flex w-full items-center gap-4 rounded-2xl px-5 py-4 text-base font-black leading-7 text-blue-900 hover:bg-white hover:shadow-lg transition-all duration-300 outline-none text-left"
                                    >
                                        <div className="p-2 rounded-xl bg-orange-100 text-orange-600 group-hover:bg-orange-600 group-hover:text-white transition-all">
                                            <NewspaperIcon className="w-6 h-6" />
                                        </div>
                                        ข่าวสารและกิจกรรม
                                    </button>

                                    <Link
                                        to="/about"
                                        onClick={() => setMobileMenuOpen(false)}
                                        className="group flex items-center gap-4 rounded-2xl px-5 py-4 text-base font-black leading-7 text-blue-900 hover:bg-white hover:shadow-lg transition-all duration-300"
                                    >
                                        <div className="p-2 rounded-xl bg-slate-100 text-slate-600 group-hover:bg-slate-600 group-hover:text-white transition-all">
                                            <InformationCircleIcon className="w-6 h-6" />
                                        </div>
                                        เกี่ยวกับเรา
                                    </Link>
                                </div>

                                <div className="py-6 border-t border-slate-200">
                                    <Link
                                        to="/"
                                        onClick={() => setMobileMenuOpen(false)}
                                        className="flex items-center justify-center gap-3 rounded-2xl bg-gradient-to-r from-blue-900 to-blue-800 px-5 py-5 text-center text-base font-black leading-7 text-white shadow-xl shadow-blue-900/30 hover:from-orange-600 hover:to-orange-500 hover:shadow-orange-500/30 transition-all duration-300 active:scale-95"
                                    >
                                        เข้าสู่หน้าหลัก
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="size-5">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                                        </svg>
                                    </Link>
                                </div>
                            </div>
                        </DialogPanel>
                    </Transition.Child>
                </Dialog>
            </Transition>

            <NewsActivity dataNewsActivity={dataNewsActivity} openModalNews={openModalNews} setOpenModalNews={setOpenModalNews} />
        </header>
    )
}

export default Navbar
